<template>
  <div>

    <div class="row">
      <div class="col-3">
        <h5 class="font-weight-bold ">موجودی انبار: {{ row.product.stock }}</h5>
      </div>
      <div class="col-3">
        <h5 class="font-weight-bold ">کسری موجودی: {{ row.stockOut }}</h5>
      </div>
      <div class="col-3">
        <h5 class="font-weight-bold ">در دست تولید: {{ row.worksCount }}</h5>
      </div>
      <div class="col-3">
        <h5 class="font-weight-bold ">برنامه ریزی شده: {{ totalCount }}</h5>
      </div>

      <div class="col-12 m-3">
        <h4 class="font-weight-bold ">توضیحات: {{ row.description }}</h4>
      </div>
    </div>

    <div class="row">
      <div class="col-3">
        <button class="btn btn-warning btn-block" @click="onTaminClicked(row.product.id)">تامین</button>
      </div>
      <div class="col-3">
        <button class="btn btn-warning btn-block" @click="getPatterns(row)">برنامه ریزی</button>
      </div>
      <div class="col-3" v-if="totalCount>0">
        <button class="btn btn-warning btn-block" @click="showPlanning(row.product.id)">مشاهده جزییات برنامه</button>
      </div>

      <!--<div class="col-3" v-if="totalCount>0">-->
      <!--<button class="btn btn-warning btn-block" @click="sendOrderToProduce()">دستور تولید</button>-->
      <!--</div>-->
    </div>

    <!--********************************************************************-->
    <b-modal id="modal-center"
             ref="productOrder"
             v-if="showModal === true"
             centered
             size="lg"
             title="برنامه ریزی تولید"
             :ok-title="'تایید'"
             :cancel-title="'لغو'"
             @ok="okModal"
    >
      <div class="row mb-2">
        <div class="col-6">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>الگوی تولید</span>
              </div>
            </div>
            <vs-select
              ref="selectPattern"
              :data="names"
              :header="{label:'name'}"
              :mode="'edit'"
              :is-header="true"
              :selected-val="selectedProductPattern"
              @dataChanged="patternSelect"
            ></vs-select>
          </div>

        </div>
        <div class="col-3">
          <div class="input-group ">
            <div class="input-group-prepend custom">
              <span class="input-group-text">تعداد</span>
            </div>
            <input class="form-control" type="number" placeholder="تعداد مورد نظر" v-model="createPatternModel.count"
                   @change="countChange"/>
          </div>
        </div>
        <div class="col-3">
          <div class="input-group ">
            <div class="input-group-prepend custom">
              <span class="input-group-text">زمان تقریبی</span>
            </div>
            <input readonly="true" class="form-control" type="number" placeholder="زمان تقریبی" v-model="planningTime"/>
          </div>
        </div>
        <div class="input-group col-sm-12 mt-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>انتخاب شیفت کاری</span>
              </div>
            </div>
            <!--<input v-model="server.name" type="text" class="form-control">-->
            <vs-select
              ref="shiftList"
              :data="shiftList"
              :header="{label:'name', multiple: true}"
              :mode="'edit'"
              :is-header="true"
              :selected-val="shiftSelectedVal"
              @onChange="onShiftChange"
            ></vs-select>
          </div>


        </div>
        <div class="input-group col-sm-6 mt-2 h-100">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <i class="icon-calendar-blank-outline"></i>
              <span>تاریخ شروع</span>
            </div>
          </div>
          <date-picker
            v-show=true
            :auto-submit="true"
            :highlight="avilableDate"
            format="jYYYY-jMM-jDD"
            @input="setDateFromDatePicker"
            ref="datePicker"
          >
            <slot>
              <input
                :readonly=true
                v-model="selsestDate"
                class="form-control date-input"
                @click="toggleStartDatePicker"
              >
            </slot>
          </date-picker>

        </div>
        <div class="input-group col-sm-6 mt-2 h-100">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <i class="icon-calendar-blank-outline"></i>
              <span>تاریخ پایان</span>
            </div>
          </div>
          <date-picker
            v-show=true
            :auto-submit="true"
            :highlight="avilableDate"
            format="jYYYY-jMM-jDD"
            @input="setDateFromDatePicker"
            ref="datePicker"
          >
            <slot>
              <input
                :readonly=true
                v-model="selsestEndDate"
                class="form-control date-input"
                @click="toggleEndDatePicker"
              >
            </slot>
          </date-picker>

        </div>
        <div class="input-group col-sm-12 mt-2 h-100">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <i class="icon-calendar-blank-outline"></i>
              <span>تعداد برنامه ریزی شده تا کنون : {{totalCount}} عدد</span>
            </div>
          </div>


        </div>

        <div class="input-group col-sm-12 text-left mt-2" style="justify-content: left;">
          <button @click="availableTime" class="btn iconed btn-danger mx-2"><i
            class="icon-bank"></i><span>محاسبه ساعات در دسترس</span></button>
          <button @click="sendPrePlanning" v-if="availableTimeList.canDoTotal" class="btn iconed btn-danger mx-2"><i
            class="icon-bank"></i><span>ذخیره برنامه</span></button>
        </div>
      </div>

      <!--</div>-->
    </b-modal>
    <!--********************************************************************-->
    <b-modal id="modal-center"
             ref="showPlanning"
             v-if="showModal === true"
             centered
             size="lg"
             title="جزئیات برنامه"
             :ok-title="'تایید'"
             :cancel-title="'لغو'"
             @ok="okModal"
    >
      <div class="row mb-2">

        <div class="input-group col-sm-12 mt-2" v-if="programCodes.length>0">
          <div class="input-group ">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>انتخاب برنامه</span>
              </div>
            </div>
            <!--<input v-model="server.name" type="text" class="form-control">-->
            <vs-select
              ref="programCodes"
              :data="programCodes"
              :header="{label:'programCode'}"
              :mode="'edit'"
              :is-header="true"
              :selected-val="programCodeSelected"
              @dataChanged="onPlaneChange"
            ></vs-select>
          </div>
        </div>
        <div class="input-group col-sm-3 text-center mt-5 " v-if="programCodeSelectedVal!=null" style="justify-content: center;">
          <date-picker
            v-show=true
            :visibel=true
            :highlight="highlightOrder"
            format="jYYYY-jMM-jDD"
            @input="setDateFromDatePicker"
            ref="datePicker3"
          >
            <slot>
              <button @click="showOrderTimesheet" class="btn iconed btn-info"><i
                class="icon-calendar-blank-outline"></i><span>تقویم برنامه</span></button>
            </slot>
          </date-picker>
        </div>
        <div class="input-group col-sm-3 text-center mt-5 " v-if="programCodeSelectedVal!=null" style="justify-content: center;">
          <button @click="showOrderTimesheetList" class="btn iconed btn-success"><i
            class="icon-file-document-box-multiple"></i><span>ساعت مورد نیاز</span></button>
        </div>
        <div class="input-group col-sm-3 text-center mt-5 " v-if="programCodeSelectedVal!=null" style="justify-content: center;">
          <button @click="getRawMaterial" class="btn iconed btn-danger"><i
            class="icon-dropbox"></i><span>مواد اولیه</span></button>
        </div>
        <div class="input-group col-sm-3 text-center mt-5 " v-if="programCodeSelectedVal!=null" style="justify-content: center;">
          <button @click="sendOrderToProduce" class="btn iconed btn-danger"><i
            class="icon-dropbox"></i><span>دستور تولید</span></button>
        </div>
        <div class="input-group col-sm-3 text-center mt-5 " v-if="programCodeSelectedVal!=null" style="justify-content: center;">
          <button @click="showdeletePlanModal" class="btn iconed btn-danger"><i
            class="icon-delete-empty"></i><span>حذف برنامه</span></button>
        </div>


      </div>

      <!--</div>-->
    </b-modal>
    <!--********************************************************************-->
    <!--********************************************************************-->
    <b-modal id="modal-center"
             ref="orderPlanningList"
             v-if="showModal === true"
             centered
             size="lg"
             title="جزئیات برنامه سفارش"
             :cancel-title="'لغو'"
             :ok-title="'بستن'"
    >
      <div class="row mb-2">
        <table class="table table-striped">
          <thead>
          <!--<tr>-->
          <!--<th scope="col" class="text-center">شماره برنامه</th>-->
          <!--</tr>-->
          </thead>
          <tbody>
          <tr v-for="(i, ind) in planningList">

            <th scope="row" class="text-center">{{planningList[ind].ordersPrograms[0].companyName}} ({{i.totalCount}} ساعت)</th>
            <!--**********************-->
            <table class="table table-striped">
              <thead>
              <tr>
                <th scope="col" class="text-center">تاریخ</th>
                <th scope="col" class="text-center">نام محصول</th>
                <th scope="col" class="text-center">نام الگو</th>
                <th scope="col" class="text-center">کارگاه</th>
                <th scope="col" class="text-center">نام شیفت</th>
                <th scope="col" class="text-center">تعداد</th>
                <th scope="col" class="text-center">ساعت</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in planningList[ind].ordersPrograms">
                <td class="text-center">{{item.date}}</td>
                <td class="text-center">{{item.productName}}</td>
                <td class="text-center">{{item.patterrnName}}</td>
                <td class="text-center">{{item.companyName}}</td>
                <td class="text-center">{{item.shiftName}}</td>
                <td class="text-center">{{item.count}}</td>
                <td class="text-center">{{item.times}}</td>

              </tr>
              </tbody>
            </table>
            <!--***********************-->
          </tr>
          </tbody>
        </table>

      </div>

      <!--</div>-->
    </b-modal>
    <!--********************************************************************-->
    <b-modal id="modal-center"
             ref="availableShiftModal"
             v-if="showModal === true"
             show="true"
             centered
             size="lg"
             title="جزئیات ساعات در دسترس"
             :cancel-title="'لغو'"
             :ok-title="'بستن'"
    >
      <div class="row mb-2">
        <h4 class="w-100 text-center">{{availableTimeList.message}}</h4>
        <table class="table table-striped">
          <thead>
          <tr>
            <td class="text-center">نام شیفت</td>
            <td v-for="(name, index0) in availableTimeList.availableShifts" class="text-center"> {{name.shiftName}}</td>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td class="text-center">زمان در دسترس شیفت
            (
              {{availableTimeList.availableShifts[availableTimeList.availableShifts.length-1].totalTime}}
            )
            </td>
            <td v-for="(count, index1) in availableTimeList.availableShifts" class="text-center">{{count.shiftCount}}</td>
          </tr>
          <tr>
            <td></td>
          </tr>
          <!--///////////////  COMPANY /////////////////////////////////////////-->
          <tr v-for="(copm, index2) in availableTimeList.companyTimes"
              :style="copm.companyAvailable < copm.companyCount ? 'background-color: rgba(255, 90, 0, 0.5);':'background-color: rgba(255, 250, 250, 0.5);' ">
            <td class="text-center">{{copm.companyName + "(" +copm.companyCount +"/" + copm.companyAvailable+ ")"}}</td>
            <td v-for="(copmcount, index3) in copm.companyAvailableShifts" class="text-center">{{copmcount.companyshiftCount}}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <!--</div>-->
    </b-modal>
    <!--********************************************************************-->

    <b-modal id="modal-center"
             ref="sentToProduct"
             v-if="showModal === true"
             centered
             size="lg"
             title="ارسال برنامه برای تولید"
             :ok-title="'ذخیره'"
             :cancel-title="'لغو'"
             @ok="sendPlanningToProduct"
    >
      <div class="row mb-2">

        <div class="input-group ">
          <div class="input-group col-8 mt-2">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>انتخاب برنامه</span>
              </div>
            </div>
            <!--<input v-model="server.name" type="text" class="form-control">-->
            <vs-select
              ref="programListNotsend"
              :data="programListNotsend"
              :header="{label:'str', multiple: true}"
              :mode="'edit'"
              :is-header="true"
              :selected-val="programListVal"
              @onChange="onProgramListChange"
            ></vs-select>
          </div>
          <div class="col-3  mt-2">
            <div class="input-group">
              <div class="input-group-prepend custom">
                <div class="input-group-text">
                  <span>اولویت</span>
                </div>
              </div>

              <vs-select
                ref="selectedPriority"
                :isHeader="true"
                :data="priority"
                :selectedVal="priority.title"
                :header="{label:'title'}"
                :mode="'edit'"
                @dataChanged="priorityTitleSelect"
                style="max-width:50% !important; "
              ></vs-select>
              <!--v-if="!sellOnly && mode!=='view'"-->
            </div>
          </div>

          <div class="input-group-prepend custom col-sm-12 mt-2">
            <div class="input-group-text">
              <span>دستورات کار </span>
            </div>
            <input type="text" class="form-control" v-model="workDescription">

          </div>
        </div>

      </div>

      <!--</div>-->
    </b-modal>
    <!--********************************************************************-->
    <b-modal id="modal-center"
             ref="deletePlanModal"
             v-if="showModal === true"
             centered
             size="lg"
             title="حذف برنامه"
             :ok-title="'حذف'"
             :cancel-title="'لغو'"
             @ok="deletPlanning"
    >
      <div class="row mb-2">

        <div class="input-group col-sm-12 mt-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>انتخاب برنامه</span>
              </div>
            </div>
            <!--<input v-model="server.name" type="text" class="form-control">-->
            <vs-select
              ref="programList"
              :data="programList"
              :header="{label:'programCode', multiple: true}"
              :mode="'edit'"
              :is-header="true"
              :selected-val="deleteprogramListVal"
              @onChange="onDeleteProgramListChange"
            ></vs-select>
          </div>
        </div>

      </div>

      <!--</div>-->
    </b-modal>
    <!--********************************************************************-->
    <b-modal id="modal-center"
             ref="rawMaterialModal"
             v-if="showModal === true"
             centered
             size="lg"
             :ok-title="'تایید'"
             title="مواد اولیه مورد نیاز"
             :cancel-title="'لغو'"
    >
      <div class="row mb-2">

        <div class="row my-2 text-center" v-if="nodataProgram">
          <div class="col-12 mt-3">
            <h5>موجودی ثبت نشده است</h5>

          </div>
        </div>
        <div class="row my-2" v-else>
          <div class="col-12 mt-3">
            <table class="table table-striped">
              <thead>
              <tr>
                <th scope="col" class="text-center">نام محصول</th>
                <th scope="col" class="text-center">واحد</th>
                <th scope="col" class="text-center">نام کارگاه</th>
                <th scope="col" class="text-center">نیاز</th>
                <th scope="col" class="text-center">موجودی</th>
                <th scope="col" class="text-center">کسری</th>
                <th scope="col" class="text-center">موجودی در سایر انبارها</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, indexprogram) in programQuantity">

                <td class="text-center">{{item.name}}</td>
                <td class="text-center">{{item.unitName}}</td>
                <td class="text-center">{{item.companyName}}</td>
                <td class="text-center">{{item.totalNeed}}</td>
                <td class="text-center">{{ item.totalQuantity < 0 ? "(" + item.totalQuantity*-1+"-)":item.totalQuantity}}</td>
                <td class="text-center">{{(item.totalNeed - item.totalQuantity) < 0 ? "---":(item.totalNeed - item.totalQuantity)}}</td>
                <td v-if="item.companyQuantitys == null">
                  <h6 class="text-center">موجودی ثبت نشده است</h6>
                </td>
                <td v-else>
                  <table class="table table-striped">
                    <thead>
                    <tr>
                      <th scope="col" class="text-center">نام کارگاه</th>
                      <th scope="col" class="text-center">موجودی انبار</th>
                      <th scope="col" class="text-center">انتقال به کارگاه الگو</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(it, indexcompany) in item.companyQuantitys">
                      <td class="text-center">{{it.companyName}}</td>
                      <td class="text-center">{{it.quantity}}</td>
                      <td class="text-center">
                        <button class="btn iconed btn-secondary"
                                @click="onTransferClicked(indexprogram,indexcompany,programQuantity[indexprogram].totalNeed)"><i
                          class="icon-content-duplicate"></i><span>انتقال</span></button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </td>

              </tr>
              </tbody>
            </table>
          </div>

        </div>

      </div>

      <!--</div>-->
    </b-modal>
    <!------------------- MODALS ------------------------------------------------------------->
    <b-modal
      ref="transferModal"
      title="انتقال به کارگاه مورد نیاز"
      size="lg"
      ok-only
      ok-title="تایید"
      @ok="transferToWorkstation"
    >
      <div class="row">
        <div class="col-12">
          <label>
            تائید انتقال کالای
            <b>{{trsfProduct}}</b>
            از کارگاه
            <b>{{trsfServe}}</b>
            به کارگاه
            <b>{{trsfRecive}}</b>
          </label>
        </div>
        <div class="col-12 my-3">
          <label>
            تعداد :
            <small>
              *توجه : تعداد قابل انتقال
              {{trsfMaxCount}}
              عدد میباشد
            </small>
          </label>
          <input class="mx-2" v-model="trsfCount" type="number" placeholder="تعداد را وارد کنید"/>
        </div>

      </div>
    </b-modal>

    <!--********************************************************************-->
  </div>
</template>

<script>

  import VsSelect from "../../_framework/VsSelect";
  import BaseService from "../../_framework/api/BaseService.js";
  import EventBus from "../../bus.js";
  import axios from "axios";
  import DatePicker from "../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
  import Moment from "moment-jalali";


  export default {
    name: 'inventory-details-planning',
    props: ['row'],
    components: {
      VsSelect,
      datePicker: DatePicker,
      Moment,
    },
    data() {
      return {
        names: [],
        selectedProductPattern: null,
        model: null,
        availableTimeList: {
          availableShifts: [{
            shiftCount: 0,
            shiftName: ""
          }],
          companyTimes: [
            {
              companyCanDo: true,
              companyCount: 0,
              companyName: "",
              companyAvailableShifts: [{
                companyshiftCount: 0,
                companyshiftName: ""
              }],
            }
          ],
          message: "",
          canDoTotal: false,
        },
        showModal: true,
        patterns: null,
        createPatternModel: {
          patternId: 0,
          count: 0,
          orderDetailId: 0
        },
        worksCount: 0,
        workDescription: "",

        planningTime: 0,
        patternTime: 0,
        numbersInTime: 1,
        shiftList: [],
        selectedShifts: [],
        shiftSelectedVal: null,

        dateClicked: 0,
        startDate: null,
        endDate: null,
        patternId: 0,
        productId: 0,
        timeSheets: [],
        disableDates: [],
        todayDate: null,
        selsestDate: null,
        selsestEndDate: null,
        planningList: [],

        planningListCount: null,
        programList: [],
        programListNotsend: [],
        totalCount: 0,
        programListVal: null,
        programListSelected: [],

        deleteprogramListVal: null,
        deleteprogramListSelected: [],
        programQuantity: [],
        nodataProgram: false,
        planningDate: [],
        tempDate: null,
        priority: [],
        selectedPriority:
          {
            title: null,
            value: 0,

          },

        programCode: "",
        trsfProduct: "",
        trsfProductId: 0,
        trsfServe: "",
        trsfServeId: 0,
        trsfRecive: "",
        trsfReciveId: 0,
        trsfMaxCount: 0,
        trsfCount: 0,
        trsfPrice: 0,
        documentTypeId: 0,
        programCodes: [],
        programCodeSelectedVal: null,
        programCodeSelected: null,
      }
    },
    mounted() {

      new BaseService('Works', '/GetWorkPriorities').getList().then((response) => {
        this.priority = response.data;

        // console.log(response.data)
      }).catch((error) => {
        console.log(error)
      });

      this.refreshTable();
      setTimeout(() => {
        // this.getOrderList();
        this.calculateWorksCount();
      }, 50);


      this.todayDate = new Date();
      this.todayDate = new Date().toJSON().slice(0, 10);
      this.tempDate = Moment(this.todayDate, "YYYY-MM-DD");
      this.todayDate = this.tempDate.format("jYYYY-jMM-jDD");
      this.getPlanningCount();
    },
    methods: {
      okModal() {
        this.refreshTable();
        setTimeout(() => {
          // this.getOrderList();
          this.calculateWorksCount();
        }, 50);
        this.getPlanningCount();
      },
      refreshTable() {
        this.show = false;
        setTimeout(() => {
          this.show = true;
        }, 50);
        // this.$refs.table.onFetchEntityList();
      },
      calculateWorksCount() {
        // console.log(this.row.worksCount);
        // this.createPatternModel.count = this.row.unitVal - this.totalCount;
        this.createPatternModel.count = this.row.unitVal - this.totalCount;
        this.worksCount = this.row.worksCount;

        if (this.row.worksCount) {
          // console.log(this.row.worksCount);
          this.createPatternModel.count -= this.worksCount;
        }
        if (this.createPatternModel.count <= 0) {
          this.createPatternModel.count = 0;
        }
        this.planningTime = Math.round((this.createPatternModel.count * this.patternTime) / this.numbersInTime);
      },
      /* onMaterialModalOk() {
         this.$emit(
           "dataChanged",
           this.headerKey,
           this.vsTableFeed.map(m => {
             return m;
           })
         );
         if (this.mode !== "create") {
           EventBus.$emit("materialChanged");
         }
       },*/
      onTaminClicked(id) {
        this.$router.push({
          path: "/supply/" + id
        });
      },
      showPlanning(id) {
        this.$refs['showPlanning'].show();
        this.getPlanningCount();
      },

      getPatterns(roww) {
        this.createPatternModel.count = roww.unitVal - this.totalCount;

        new BaseService('Patterns', `/GetProductPatterns/${roww.product.id}`).getList().then((response) => {
          this.names = response.data;
          if (this.names.length <= 0) {
            this.showModal = false;
            this.$noty.warning("این محصول الگویی برای تولید ندارد")
            // console.log(this.showModal)
          }
          this.patternTime = response.data.standardTime;
          this.$refs['productOrder'].show();
          // this.getPlanningCount();

        }).catch((error) => {
          console.log(error)
        }).then(() => {

        });

        new BaseService('Time', '/GetShift').getList().then((response) => {
          this.shiftList = response.data;

        }).catch((error) => {
          console.log(error)
        });

        new BaseService('Time', '/GetTimeSheet').getList().then((response) => {
          this.timeSheets = response.data;
          this.disableDates = [];
          for (let i = 0; i < this.timeSheets.length; i++) {
            // console.log(this.timeSheets[i].dateTime);
            // this.timeSheets[i].jdateTime = Moment(this.timeSheets[i].dateTime.substring(0, 10), "YYYY-MM-DD").format("jYYYY-jMM-jDD");
            // this.disableDates.push(this.timeSheets[i].jdateTime);
            this.disableDates.push(Moment(this.timeSheets[i].dateTime.substring(0, 10), "YYYY-MM-DD").format("jYYYY-jMM-jDD"));
          }

        }).catch((error) => {
          console.log(error)
        });
      },
      getOrderList() {
        new BaseService('ProductionManagements', '/GetManageOrder').getList().then((response) => {
          this.refreshTable()
        }).catch((error) => {
          console.log(error)
        });
      },
      sendToWork() {
        this.getPlanningCount();
        this.sendOrderToProduce();

      },
      sendOrderToProduce() {
        this.$refs['sentToProduct'].show();
        this.programListNotsend = [];
        for (let i = 0; i < this.programList.length; i++) {
          if (!this.programList[i].sendToWorkstation) {
            let str = this.programList[i].programCode + " تعداد " + this.programList[i].counts + " عدد";
            this.programList[i].str = str;
            this.programListNotsend.push(this.programList[i]);
          }
        }
        // console.log(this.programListNotsend)
        // new BaseService('Works', '/GetWorkPriorities').getList().then((response) => {
        //   this.priority = response.data;
        //
        //   // console.log(response.data)
        // }).catch((error) => {
        //   console.log(error)
        // });
      },
      patternSelect(prop, data) {
        this.patternId = data.id;
        this.productId = data.productId;
        this.patternTime = data.standardTime;

        this.totalCount = this.row.unitVal;
        let prods = data.rawMaterials;
        for (let pr of prods) {
          if (pr.productId === this.productId) {
            this.numbersInTime = pr.count;
          }
        }
        this.planningTime = Math.round((this.createPatternModel.count * this.patternTime) / this.numbersInTime);
      },
      countChange() {
        this.planningTime = Math.round((this.createPatternModel.count * this.patternTime) / this.numbersInTime);
      },
      onShiftChange(val) {
        this.selectedShifts = [];

        if (val !== null && val !== undefined) {
          for (let item of val) {
            this.selectedShifts.push(item.id)
          }
        }
      },
      onProgramListChange(val) {
        this.programListSelected = [];
        if (val !== null && val !== undefined) {
          for (let item of val) {
            this.programListSelected.push(item.programCode)
          }
        }
      },
      onDeleteProgramListChange(val) {
        this.deleteprogramListSelected = [];
        if (val !== null && val !== undefined) {
          for (let item of val) {
            this.deleteprogramListSelected.push(item.programCode)
          }
        }
      },
      toggleStartDatePicker() {
        this.dateClicked = 1;
        this.$refs.datePicker.togglePicker();
      },
      toggleEndDatePicker() {
        this.dateClicked = 2;
        this.$refs.datePicker.togglePicker();
      },
      setDateFromDatePicker(date) {
        if (this.dateClicked === 1) {
          this.selsestDate = date;
          let sdate = Moment(date, "jYYYY/jMM/jDD");
          this.startDate = sdate.format("YYYY-MM-DD");
          // this.sendPrePlanning();
        }
        if (this.dateClicked === 2) {
          this.selsestEndDate = date;
          let sdate = Moment(date, "jYYYY/jMM/jDD");
          this.endDate = sdate.format("YYYY-MM-DD");
          // this.sendPrePlanning();
        }

      },
      sendPrePlanning() {
        if (this.startDate === null) {
          this.$noty.error("لطفا تاریخ شروع برنامه را انتخاب کنید");
        } else if (this.endDate === null) {
          this.$noty.error("لطفا تاریخ پایان برنامه را انتخاب کنید");
        } else if (this.patternId === 0) {
          this.$noty.error("لطفا الگوی تولید را انتخاب کنید");
        } else if (this.createPatternModel.count === 0) {
          this.$noty.error("لطفا تعداد را انتخاب کنید");
        } else if (this.selectedShifts === null || this.selectedShifts.length === 0) {
          this.$noty.error("لطفا شیفتهای کاری را انتخاب کنید");
        } else {
          let model = {
            startDate: this.startDate,
            endDate: this.endDate,
            orderId: this.row.id,
            patternId: this.patternId,
            productId: this.productId,
            count: this.createPatternModel.count,
            shifts: this.selectedShifts,

          };
          new BaseService('Planning', '/CheckPlanningsWithDate').create(model).then((response) => {
            // console.log("ok button clicked");
            this.$noty.success(response.data);
            this.getProgramCode();
          }).catch((error) => {
            console.log(error)
            // TODO: change error message and put if condition for it
            // this.$noty.error("عدد کار برای این سفارش ثبت شده و دیگر نمیتوانید کار جدید ثبت کنید")
          });
        }
      },
      availableTime() {
        if (this.startDate === null) {
          this.$noty.error("لطفا تاریخ شروع برنامه را انتخاب کنید");
        } else if (this.endDate === null) {
          this.$noty.error("لطفا تاریخ پایان برنامه را انتخاب کنید");
        } else if (this.patternId === 0) {
          this.$noty.error("لطفا الگوی تولید را انتخاب کنید");
        } else if (this.createPatternModel.count === 0) {
          this.$noty.error("لطفا تعداد را انتخاب کنید");
        } else if (this.selectedShifts === null || this.selectedShifts.length === 0) {
          this.$noty.error("لطفا شیفتهای کاری را انتخاب کنید");
        } else {
          let model = {
            startDate: this.startDate,
            endDate: this.endDate,
            orderId: this.row.id,
            patternId: this.patternId,
            productId: this.productId,
            count: this.createPatternModel.count,
            shifts: this.selectedShifts,

          };
          new BaseService('Planning', '/CheckPlanningsAvailableTime').create(model).then((response) => {
            console.log(response.data);
            this.availableTimeList = response.data;
            var tot =0;
            for (let i of this.availableTimeList.availableShifts) {
              tot += i.shiftCount;
              i.totalTime = tot;
            }
            // if (this.availableTimeList !== null) {
            //   for (let c of this.availableTimeList.companyTimes) {
            //     c.companyAvailableShifts=[];
            //     c.companyCount2=c.companyCount;
            //     for (let i of this.availableTimeList.availableShifts) {
            //       if (c.companyCount<=0){
            //         let b = {
            //           companyshiftCount: 0
            //         };
            //         c.companyAvailableShifts.push(b);
            //       }else {
            //         if (c.companyCount > i.shiftCount) {
            //           let a = {
            //             companyshiftCount: i.shiftCount
            //           };
            //           c.companyCount -= i.shiftCount;
            //           c.companyAvailableShifts.push(a);
            //         } else {
            //           let b = {
            //             companyshiftCount: c.companyCount
            //           };
            //           c.companyCount -= c.companyCount;
            //           c.companyAvailableShifts.push(b);
            //         }
            //       }
            //     }
            //   }
            // }
            // this.showModal =true;
            this.$refs['availableShiftModal'].show();

          }).catch((error) => {
            console.log(error);
            // TODO: change error message and put if condition for it
            // this.$noty.error("عدد کار برای این سفارش ثبت شده و دیگر نمیتوانید کار جدید ثبت کنید")
          });
        }
      },
      avilableDate(formatted, dateMoment, checkingFor) {


        let attributes = {'title': 'بدون تعریف' + formatted};
        for (let i = 0; i < this.disableDates.length; i++) {
          if (checkingFor === 'day' && formatted === this.disableDates[i]) {
            // console.log("28")
            attributes['style'] = 'background-color: #f9e1be !important; ';
            attributes['title'] = 'این روز در تقویم کاری تعریف شده است';
          }
        }
        return attributes;
      },
      showOrderTimesheet() {
        this.$refs.datePicker3.togglePicker();
      },
      showOrderTimesheetList() {
        this.$refs['orderPlanningList'].show();
      },
      showdeletePlanModal() {
        this.$refs['deletePlanModal'].show();
      },
      getPlanningCount() {
        let model = {
          orderId: this.row.id,
          patternId: this.patternId,
          productId: this.row.product.id,
        };
        new BaseService('Planning', '/GetOrderTimeSheetCount').create(model).then((response) => {
          // console.log("ok button clicked");
          this.planningListCount = response.data;
          this.programList = this.planningListCount.ordersPlans;
          this.totalCount = this.planningListCount.totalCount;
          if (this.totalCount > 0) {
            this.getProgramCode();
            // this.getPlanningData();
          }
        }).catch((error) => {
          // TODO: change error message and put if condition for it
          // this.$noty.error("عدد کار برای این سفارش ثبت شده و دیگر نمیتوانید کار جدید ثبت کنید")
        });
      },
      getProgramCode() {
        let model = {
          orderId: this.row.id,
          patternId: this.patternId,
          productId: this.row.product.id,
        };
        new BaseService('Planning', '/GetProgramCodeOrder').create(model).then((res) => {
          this.programCodes = res.data;
          if (this.programCodes.length == 1) {
            this.programCodeSelectedVal = this.programCodes[0];
            this.getPlanningData();
          }

        }).catch((error) => {
          Utils.handleErrorWithNotification("لیست وقفه پیدا نشد", this.$noty);
          console.log(error)
        });
        // this.getPlanningData();
      },
      getPlanningData() {
        this.getPlanningList();
        this.getPlanningTime();
        // this.getPlanningCount();
      },
      getPlanningList() {
        new BaseService('Planning', '/GetOrderTimeSheetByPogramCode').create(this.programCodeSelectedVal).then((response) => {
          // console.log("ok button clicked");
          this.planningList = response.data;
          if (this.planningList.length > 0) {
            for (let i = 0; i < this.planningList.length; i++) {
              for (let j = 0; j < this.planningList[i].ordersPrograms.length; j++) {
                // console.log(this.timeSheets[i].dateTime);
                this.planningList[i].ordersPrograms[j].date = Moment(this.planningList[i].ordersPrograms[j].date.substring(0, 10), "YYYY-MM-DD").format("jYYYY-jMM-jDD");
              }
            }
          }
          // this.$noty.success(response.data);

        }).catch((error) => {
          // TODO: change error message and put if condition for it
          // this.$noty.error("عدد کار برای این سفارش ثبت شده و دیگر نمیتوانید کار جدید ثبت کنید")
        });
      },
      getPlanningTime() {

        new BaseService('Planning', '/GetOrderTimeSheetByDate').create(this.programCodeSelectedVal).then((response) => {
          // console.log("ok button clicked");
          this.planningDate = response.data;
          if (this.planningDate.length > 0) {
            for (let i = 0; i < this.planningDate.length; i++) {
              // console.log(this.timeSheets[i].dateTime);
              this.planningDate[i].date = Moment(this.planningDate[i].date.substring(0, 10), "YYYY-MM-DD").format("jYYYY-jMM-jDD");
            }
          }
          // this.$noty.success(response.data);

        }).catch((error) => {
          // TODO: change error message and put if condition for it
          // this.$noty.error("عدد کار برای این سفارش ثبت شده و دیگر نمیتوانید کار جدید ثبت کنید")
        });
      },
      getRawMaterial() {

        new BaseService('Planning', '/GetRawMaterialFromProgramCode/' + this.programCodeSelectedVal.programCodeId).getList().then((response) => {
          if (response.data === null || response.data == "") {
            this.nodataProgram = true;
          } else {
            this.nodataProgram = false;
            this.programQuantity = [];
            this.programQuantity = response.data;
          }
          this.$refs['rawMaterialModal'].show();

        }).catch((error) => {
          Utils.handleErrorWithNotification("لیست وقفه پیدا نشد", this.$noty);
          console.log(error)
        });
      },
      highlightOrder(formatted, dateMoment, checkingFor) {
        let attributes = {'title': ''};
        for (let i = 0; i < this.planningDate.length; i++) {
          if (checkingFor === 'day' && formatted === this.planningDate[i].date) {
            // console.log("28")
            attributes['style'] = 'background-color: #a7a040 !important; ';
            let str = "";
            for (let j = 0; j < this.planningDate[i].ordersPlans.length; j++) {
              str = str + ' | ' +
                this.planningDate[i].ordersPlans[j].productName + ' با الگوی ' +
                this.planningDate[i].ordersPlans[j].patterrnName + ' در کارگاه ' +
                this.planningDate[i].ordersPlans[j].companyName + ' کد برنامه ' +
                this.planningDate[i].ordersPlans[j].programCode + ' در شیفت ' +
                this.planningDate[i].ordersPlans[j].shiftName + ' از ساعت ' +
                this.planningDate[i].ordersPlans[j].times;
            }
            attributes['title'] = str;
          }
        }
        return attributes;
      },
      deletPlanning() {
        // let model = {
        //   orderId: this.row.id,
        //   patternId: this.patternId,
        //   productId: this.row.product.id,
        // };
        // console.log(model);
        new BaseService('Planning', '/DeletePogramCode').create(this.deleteprogramListSelected).then((response) => {
          // console.log("ok button clicked");
          // this.planningListCount = response.data;
          // this.programList = this.planningListCount.ordersPlans;
          // this.totalCount = this.planningListCount.totalCount;
          this.$noty.success(response.data);
          // this.getPlanningData();
          this.getProgramCode();
        }).catch((error) => {
          // TODO: change error message and put if condition for it
          this.$noty.error("" + error)
        });
      },
      priorityTitleSelect(prop, data) {
        this.selectedPriority.value = data.value;
        // console.log(this.parameters.priority);
        // if (data && data.id) {
        //   this.voucherModel.documentTypeId = data.id;
        // } else {
        //   this.voucherModel.documentTypeId = null;
        // }
      },
      sendPlanningToProduct() {
        if (this.programListSelected.length > 0) {
          let model = {
            priority: this.selectedPriority.value,
            description: this.workDescription,
            programCode: this.programListSelected

          };
          new BaseService('Planning', '/CreateWorkFromProgramCode').create(model).then((response) => {
            this.$noty.success(response.data);
            this.getOrderList();
            this.getPlanningCount();
          }).catch((error) => {
            // TODO: change error message and put if condition for it
            this.$noty.error(error);
          });
        } else {
          this.$noty.error("لطفا کدهای برنامه را انتخاب کنید");
        }
      },
      onTransferClicked(workIndex, companyIndex, source) {
        this.getDocumentTypes();
        this.trsfProduct = this.programQuantity[workIndex].name;
        this.trsfProductId = this.programQuantity[workIndex].productId;
        this.trsfRecive = this.programQuantity[workIndex].companyName;
        this.trsfReciveId = this.programQuantity[workIndex].companyId;
        this.trsfServe = this.programQuantity[workIndex].companyQuantitys[companyIndex].companyName;
        this.trsfServeId = this.programQuantity[workIndex].companyQuantitys[companyIndex].companyId;
        this.trsfMaxCount = this.programQuantity[workIndex].companyQuantitys[companyIndex].quantity;
        this.trsfPrice = this.programQuantity[workIndex].companyQuantitys[companyIndex].price;
        this.trsfCount = this.programQuantity[workIndex].totalNeed;
        this.$refs.transferModal.show();
      },
      getDocumentTypes() {
        new BaseService('documentTypes').getList().then((response) => {
            let ducTypes = response.data;
            let find = false;
            let index = 0;
            for (let i = 0; i < ducTypes.length; i++) {
              if (ducTypes[i].name === 'انتقال به کارگاه دیگر') {
                find = true;
                index = i;
                break;
              }
            }
            if (find) {
              this.documentTypeId = ducTypes[index].id;
            } else {
              let data = {
                name: 'انتقال به کارگاه دیگر',
                type: 2
              };
              new BaseService('documentTypes').create(data).then((response) => {
                  // g(response.data);
                  this.documentTypeId = response.data.id;
                }
              ).catch((error) => {
                console.log(error)
              })
            }

          }
        ).catch((error) => {
          console.log(error)
        })
      },
      transferToWorkstation() {
        if (this.trsfCount == 0) {
          Utils.handleErrorWithNotification("تعداد انتقالی نمیتواند صفر باشد", this.$noty);
        } else if (this.trsfCount > this.trsfMaxCount) {
          Utils.handleErrorWithNotification("تعداد انتقالی نمیتواند از موجودی بیشتر باشد", this.$noty);
        } else {
          // this.hideModal();
          let todayDate = new Date();

          todayDate = new Date().toJSON().slice(0, 10);

          let data = {
            description: "انتقال به انبار کارگاه دیگر",
            documentTypeId: this.documentTypeId,
            receiveOutSourceId: null,
            receiverCompanyId: this.trsfReciveId,
            serveCompanyId: this.trsfServeId,
            serveOutSourceId: null,
            voucherDate: todayDate,
            voucherProductDto: [{
              productId: this.trsfProductId,
              unitVal: this.trsfCount,
              price: this.trsfPrice,
              productName: this.trsfProduct,

            }],
          };

          new BaseService('voucher').create(data).then((response) => {
              this.$noty.success("انتقال با موفقیت انجام شد");

            }
          ).catch((error) => {
            console.log(error)
          })

        }
      },
      onPlaneChange(prop, data) {
        if (data !== null && data !== undefined) {
          this.programCodeSelectedVal = {};
          this.programCodeSelectedVal.orderId = data.orderId;
          this.programCodeSelectedVal.patternId = data.patternId;
          this.programCodeSelectedVal.productId = data.productId;
          this.programCodeSelectedVal.programCode = data.programCode;
          this.programCodeSelectedVal.programCodeId = data.programCodeId;
          this.getPlanningData();
        }
      },

    }
  }

</script>

<style scoped lang="scss">
  .black {
    color: black;
  }
</style>
